// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'all.public',
    path: 'P0101Article/list',
    name: 'PgP0101List',
    component: () => import('./PgP0101List')
  },
  {
    portalGroup: 'all.admin',
    path: 'P0101Article/view/:id',
    name: 'PgP0101View',
    component: () => import('./PgP0101View')
  },
  {
    portalGroup: 'all.admin',
    path: 'P0101Article/form/:id?',
    name: 'PgP0101Form',
    component: () => import('./PgP0101Form')
  },
  {
    portalGroup: 'all.admin',
    path: 'P0101Article/index',
    name: 'PgP0101MultiPage',
    component: () => import('./PgP0101MultiPage')
  },
  {
    portalGroup: 'all.admin',
    path: 'P0101Article/single',
    name: 'PgP0101SinglePage',
    component: () => import('./PgP0101SinglePage')
  },
  {
    portalGroup: 'press.my',
    path: 'P0101ArticleMy/index',
    name: 'PgP0101MultiPageMy',
    component: () => import('./PgP0101MyPage')
  },
  {
    portalGroup: 'press.my',
    path: 'P0101Article/view/:id',
    name: 'PgP0101View',
    component: () => import('./PgP0101View')
  },
  {
    portalGroup: 'press.my',
    path: 'P0101Article/form/:id?',
    name: 'PgP0101Form',
    component: () => import('./PgP0101Form')
  }

]
